<div class="logo-container">
  <img src="assets/imgs/FINAL_Pasture_Por_ by_Ag_Innovations_logo.png">
</div>
<div class="title">
  <mat-label>MADE FOR THE LAND</mat-label>
</div>
<mat-card>
  <mat-card-content>
    <form [formGroup]="form" (ngSubmit)="submitLogin(form.value)">

        <mat-form-field>
          <mat-label>Username</mat-label>
          <input matInput type="text" formControlName="userName">
        </mat-form-field>

        <mat-form-field>
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password">
        </mat-form-field>

      <div class="button">
        <button type="submit" mat-raised-button color="primary">Login</button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
